// extracted by mini-css-extract-plugin
module.exports = {"price":"pA-z","onSale":"qA-z"};